import { render, staticRenderFns } from "./ScriptAdmin.vue?vue&type=template&id=59b8f831&scoped=true&"
import script from "./ScriptAdmin.vue?vue&type=script&lang=js&"
export * from "./ScriptAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b8f831",
  null
  
)

export default component.exports